<template>
    <div>
        <h4>{{ value.firstName }} {{ value.lastName }}</h4>
        <h6 class="mt-2">
            <span> tz: {{ value.tz }} </span>
        </h6>
        <div class="flex-row">
            <h6>
                <span> Is Aguda member: </span>
            </h6>
            <h6 v-if="value.isAgudaMember" class="text-green ml-1">
                <span>YES</span>
            </h6>
            <h6 v-else class="text-red ml-1">
                <span>NO</span>
            </h6>
        </div>
        <div class="form-group col-12 mt-2">
            <label for="name">Category name</label>

            <v-select
                v-model="selectedCategory"
                label="name"
                placeholder="Search..."
                :options="categories"
                :class="{
                    'is-invalid': hasError('categoryId')
                }"
                @search="onCategorySearch"
            >
                <template slot="no-options">
                    Start typing to search for a category
                </template>
            </v-select>

            <div class="invalid-feedback">
                {{ getError('categoryId') }}
            </div>
        </div>

        <div class="form-group col-12">
            <label for="name">Tag Name</label>
            <v-select
                v-model="tag"
                label="name"
                placeholder="Search..."
                :disabled="!isSelectedCategoryId"
                :options="tags"
                :class="{
                    'is-invalid': hasError('name')
                }"
                @search="onTagSearch"
            >
                <template slot="no-options">
                    Start typing to search for a tag
                </template>
            </v-select>

            <div class="invalid-feedback">
                {{ getError('name') }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            tag: {
                category: {}
            },
            tags: [],
            categories: [],
            selectedCategory: null
        };
    },

    computed: {
        isSelectedCategoryId() {
            return this.selectedCategory?.id;
        }
    },

    watch: {
        tag() {
            this.$emit('input', { ...this.value, tag: this.tag });
        },

        selectedCategory(value) {
            if (value?.id) {
                this.tag.category.id = value.id;

                this.fetchTags(value.id);
            } else {
                this.tag = { category: {} };
            }
        }
    },

    async created() {
        const { tag } = this.value;

        if (tag?.id) {
            this.tag = {
                ...tag,
                categoryId: tag.category ? tag.category.id : null
            };

            this.selectedCategory = tag.category ? { ...tag.category } : null;
        }

        const { rows: categories } = await this.getCategories();

        this.categories = categories;
    },

    methods: {
        ...mapActions({
            getCategories: 'studentTagCategories/index',
            getTags: 'studentTags/index'
        }),

        async fetchTags(categoryId) {
            const { rows: tags } = await this.getTags({
                filters: {
                    categoryId: {
                        value: categoryId,
                        type: 'substring'
                    }
                }
            });

            this.tags = tags;
        },

        async onCategorySearch(search, loading) {
            if (search.length) {
                loading(true);

                const { rows: categories } = await this.getCategories({
                    search
                });

                this.categories = categories;

                loading(false);
            }
        },

        async onTagSearch(search, loading) {
            if (search.length) {
                loading(true);

                const { rows: tags } = await this.getTags({
                    search,
                    filters: {
                        categoryId: {
                            value: this.selectedCategory.id,
                            type: 'substring'
                        }
                    }
                });

                this.tags = tags;

                loading(false);
            }
        },

        hasError(key) {
            return this.serverErrors.find(error => error.param === key);
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                [],
                this.serverErrors,
                key
            );
        }
    }
};
</script>
